<template>
    <div class="table-organization py-5">
        <input-organization v-for="row in rows" :key="row.id" :value="row.name" :id="row.id" :tagId="tagId" />
        <create-organization :tagId="tagId" :organizations="rows" />
    </div>
</template>

<script>
import InputOrganization from "./input";
import CreateOrganization from "./create";

export default {
    props: {
        rows: {
            type: Array
        },
        tagId: {
            type: Number
        }
    },
    components: {
        InputOrganization,
        CreateOrganization
    }
}
</script>

<style lang="scss">
.table-organization {
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    grid-gap: 16px;
}
</style>